declare global {
  interface Window {
    env: any;
  }
}
interface EnvType {
  REACT_APP_ENVIRONMENT: string;
  REACT_APP_VERSION: string;
  REACT_APP_BFF_API: string;
  REACT_APP_BFF_API_DOCS: string;
  REACT_APP_AAD_AUTHORITY: string;
  REACT_APP_AAD_CLIENT_ID: string;
  REACT_APP_AAD_LOGIN_REDIRECT_URI: string;
  REACT_APP_AAD_LOGOUT_REDIRECT_URI: string;
  REACT_APP_AAD_SCOPES: string;
  REACT_APP_BFF_MAX_FILESIZE_MB: number;
  REACT_APP_SUPPORT_EMAIL: string;
  REACT_APP_BFF_PATH_LOGIN: string;
  REACT_APP_BFF_PATH_LANDING: string;
  REACT_APP_BFF_PATH_SUMMARY: string;
  REACT_APP_BFF_PATH_API: string;
  REACT_APP_BFF_PATH_SUPPORT: string;
  REACT_APP_BFF_PATH_FEEDBACK: string;
  REACT_APP_BFF_PATH_SOMETHING_MISSING: string;
  REACT_APP_BFF_PATH_SORRY: string;
  REACT_APP_BFF_PATH_FORBBIDEN: string;
  REACT_APP_BFF_PATH_COSTS: string;
  REACT_APP_BFF_PATH_COVERAGE_CHECK_2: string;
  REACT_APP_BFF_PATH_COST_METERING: string;
  REACT_APP_BFF_PATH_COST_ESTIMATOR: string;
  REACT_APP_AAD_ENABLED: string;
  REACT_APP_SHOW_BETA_MODAL: string;
  REACT_APP_DOC_GENERATOR_URL: string;
}

export const env: EnvType = { ...process.env, ...window.env };
